import React from "react"
import { Permissions } from 'components'

const fieldsTyps = {
    disabled: (props) => <Permissions.Disabled  {...props} />,
    hidden: (props) => <Permissions.Hidden  {...props} />,
    gridColumn: (props) => <Permissions.GridColumn  {...props} />,
}

export default fieldsTyps 